var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('p',{staticClass:"tw-text-[0.7rem] tw-font-semibold"},[_vm._v("For Research Use Only. Not for Use in Diagnostic Procedures.")])])}]

export { render, staticRenderFns }